import { useTranslation } from 'react-i18next';
import BankIDIcon from 'assets/icons/ico-bankid.svg?react';
import Typography from 'components/Typography/Typography';

import AirBankIcon from 'assets/psd2/AIRBANK.svg?react';
import CeskasBankIcon from 'assets/psd2/CSAS.svg?react';
import CreditasBankIcon from 'assets/psd2/CREDITAS.svg?react';
import CSOBBankIcon from 'assets/psd2/CSOB.svg?react';
import KBBankIcon from 'assets/psd2/KB.svg?react';
import MBankIcon from 'assets/psd2/MBANK.svg?react';
import MonetaBankIcon from 'assets/psd2/MONETA.svg?react';
import RaiffeisenBankIcon from 'assets/psd2/RAIFFEISEN.svg?react';
import s from './InternetBanking.module.scss';
import IntroModalContent from './IntroModalContent';

function BankIDModal() {
  const { t } = useTranslation('intro');
  return (
    <IntroModalContent
      heading={t('modal_bankId.heading')}
      iconComponent={<BankIDIcon />}
      points={[
        t('modal_bankId.point_1') as string,
        t('modal_bankId.point_2') as string,
        t('modal_bankId.point_3') as string,
        t('modal_bankId.point_4') as string,
      ]}
    >
      <Typography
        kind="h3"
        size="m"
        fontWeight={700}
        className={s['section-heading']}
      >
        {t('modal_internet_banking.supported_banks')}
      </Typography>

      <div className={s.grid}>
        <div className={s.itemLeft}>
          <CeskasBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <CreditasBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <MonetaBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <RaiffeisenBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <AirBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <MBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <CSOBBankIcon className={s.icon} />
        </div>
        <div className={s.itemLeft}>
          <KBBankIcon className={s.icon} />
        </div>
      </div>
    </IntroModalContent>
  );
}

export default BankIDModal;
